import loader from '../libs/bx-custom-loader';
import {fromEvent, map, mapTo, merge, scan, share} from 'rxjs';
import {add, lte} from 'ramda';
import createLoader from '../functions/createLoader';
import getScrollbarWidth from '../functions/getScrollbarWidth';
import Vue from "vue";

const cssScrollSize = '--ua-scroll-size';
const {body} = document;
let inited = false;

export default function initLoader() {
    if (inited) return;

    const preservedPadding = getScrollbarWidth();
    // const loaderElem = createLoader();
    const loaderElem = new Vue({
        render: createLoader,
    });
    loaderElem.$mount();
    const show$ = fromEvent(loader, 'showWait').pipe(share());
    const hide$ = fromEvent(loader, 'closeWait');

    show$.subscribe(event => event.detail.hidden = true);

    const loaders$ = merge(
        show$.pipe(mapTo(1)),
        hide$.pipe(mapTo(-1))
    ).pipe(
        scan(add, 0),
        map(lte(1))
    );

    loaders$.subscribe((isShown) => {
        if (isShown) {
            body.appendChild(loaderElem.$el);
            body.style.setProperty('overflow', 'hidden');
            body.classList.add('is-scroll-disabled');
        } else {
            loaderElem.$el.parentElement?.removeChild(loaderElem.$el);
            body.style.removeProperty('overflow');
            body.classList.remove('is-scroll-disabled');
        }
    });

    inited = true;
}
